import { render } from "./Turns.vue?vue&type=template&id=63c5632c"
import script from "./Turns.vue?vue&type=script&lang=js"
export * from "./Turns.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__